import { render, staticRenderFns } from "./systemMenu.vue?vue&type=template&id=0c83474c&scoped=true"
import script from "./systemMenu.vue?vue&type=script&lang=js"
export * from "./systemMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c83474c",
  null
  
)

export default component.exports